import styles from './FJHeaderPanel.module.less';
import PropTypes from 'prop-types';
import FJBetaIcon from '../../../assets/svg/aiVideoClip/beta.svg?react';
import LogoIcon from '../../../assets/svg/logo.svg?react';
import FJArrowIcon from '../../../assets/svg/button-pull-down.svg?react';
import FJStarIcon from '../../../assets/svg/star.svg?react';
import FJBackIcon from '../../../assets/svg/community/back.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJDropDown from '../../../common/components/FJDropDown/FJDropDown';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJHeaderConfig, { FJHeaderTools } from '../../../config/FJHeaderConfig.js';
import FJTextWithEllipsis from '../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import { LOCAL } from '../../../constants/FJEvnConstant';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJConfig from '../../../config/FJConfig.js';
import FJCommunityUtil from '../../../util/FJCommunityUtil.js';
const environment = import.meta.env.MODE;
const isLocal = environment === LOCAL;

const FJHeaderPanel = ({ hideDropdown = false, onLogoClick, onCommunityClick }) => {
    const curLag = FJLocalStore.currentTag();
    const _getHref = useCallback(
        href => {
            return isLocal ? href.replace('/apply', '') : `/${curLag}${href}`;
        },
        [curLag],
    );
    const onClick = item => {
        if (item.isNewWindow) {
            window.open(_getHref(item.href), '_blank');
        } else {
            location.href = _getHref(item.href);
        }
    };
    const mouseDownHeaderDropdown = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    }, []);
    const [visible, setVisible] = useState(false);
    const [currentTool] = useState(() => {
        return FJHeaderConfig.aiMenuList.find(item => item.href.includes(location.pathname));
    });

    const _overlayRef = useRef(null);
    const [overlayHeight, setOverlayHeight] = useState('auto');
    useLayoutEffect(() => {
        if (visible) {
            _updateHeight();
        }
    }, [visible]);

    useEffect(() => {
        const _initHeight = () => {
            setOverlayHeight('auto');
            _updateHeight();
        };
        window.addEventListener('resize', _initHeight);
        return () => {
            window.removeEventListener('resize', _initHeight);
        };
    }, []);

    const _updateHeight = () => {
        if (!_overlayRef.current) return;
        const overlayRect = _overlayRef.current.getBoundingClientRect();
        const clientHeight = document.body.clientHeight;

        if (overlayRect.top + overlayRect.height + 40 > clientHeight) {
            setOverlayHeight(clientHeight - overlayRect.top - 40);
        } else {
            setOverlayHeight('auto');
        }
    };

    return (
        <div className={styles.header_panel}>
            <div onClick={onLogoClick} className={styles.logo_box}>
                <LogoIcon />
            </div>
            {!hideDropdown && (
                <FJDropDown
                    triggerDisplay='flex'
                    placement='bottomLeft'
                    onShow={() => {
                        setVisible(true);
                    }}
                    onHide={() => {
                        setVisible(false);
                    }}
                    overlay={
                        <div className={styles.overlay_box} style={{ height: visible ? overlayHeight : 'auto' }}>
                            <FJVerticalScroller style={{ height: '100%' }}>
                                <div
                                    className={styles.community_header}
                                    onClick={onCommunityClick}
                                    style={{ backgroundImage: `url(${FJConfig.imgPath}community/my-space-bg.png)` }}
                                >
                                    <div className={styles.icon_container}>
                                        <FJBackIcon className={styles.back_icon_first} />
                                        <FJBackIcon className={styles.back_icon_second} />
                                    </div>
                                    {FJLocalStore._('explore-the-ai-community')}
                                </div>
                                <div className={styles.ai_menu_list} ref={_overlayRef}>
                                    {FJHeaderTools.map(group => {
                                        const { groupName, children } = group;
                                        return (
                                            <div key={groupName} className={styles.group_item}>
                                                <div className={styles.group_name}>{FJLocalStore._(groupName)}</div>
                                                <div className={styles.children_box}>
                                                    {children.map(item => {
                                                        return (
                                                            <div
                                                                key={item.title}
                                                                className={styles.ai_menu_item}
                                                                onClick={() => onClick(item)}
                                                            >
                                                                <item.icon className={styles.ai_menu_icon} />
                                                                <FJTextWithEllipsis
                                                                    text={
                                                                        FJLocalStore._(item.title) +
                                                                        (item.titleSuffix ? item.titleSuffix : '')
                                                                    }
                                                                    isRender={visible}
                                                                />
                                                                {item.hasBeta && <FJBetaIcon />}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </FJVerticalScroller>
                        </div>
                    }
                    triggerClick={mouseDownHeaderDropdown}
                >
                    <div className={styles.ai_menu_btn}>
                        {currentTool ? (
                            <>
                                <currentTool.icon className={styles.ai_menu_icon} />
                                <div className={styles.current_menu_title}>{FJLocalStore._(currentTool.title)}</div>
                            </>
                        ) : (
                            <>
                                <FJStarIcon className={styles.ai_menu_icon} />
                                <div className={styles.current_menu_title}>{FJLocalStore._('more-ai-tools')}</div>
                            </>
                        )}
                        <FJArrowIcon className={styles.arrow_icon} />
                    </div>
                </FJDropDown>
            )}
        </div>
    );
};

FJHeaderPanel.propTypes = {
    hideDropdown: PropTypes.bool,
    onLogoClick: PropTypes.func,
    onCommunityClick: PropTypes.func,
};

export default FJHeaderPanel;
